export const socialShare = () => {
  const shareLinks = document.querySelectorAll(
    '.c-social-share .c-social-share__link',
  );

  if (!shareLinks.length) return;

  shareLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      window.open(link.href, 'genv_share', 'width=600,height=530');
    });
  });
};
